export const organizationInformationReportApi = 'report-management/org-info-report/list'
export const circularPublicationReport = 'reportManagement/circular/publication/list'
// Committee Management
export const committeeListApi = 'training-e-learning-service/committee-management/list'
export const committeeStoreApi = 'training-e-learning-service/committee-management/store'
export const committeeUpdateApi = 'training-e-learning-service/committee-management/update'
export const committeeToggleApi = 'training-e-learning-service/committee-management/toggle-status'

// course module management Management
export const courseModuleListApi = 'training-e-learning-service/detailed-syllabus/list'
export const courseModuleStoreApi = 'training-e-learning-service/detailed-syllabus/store'
export const courseModuleUpdateApi = 'training-e-learning-service/detailed-syllabus/update'
export const courseModuleToggleApi = 'training-e-learning-service/detailed-syllabus/toggle-status'

// assign course trainer
export const assignCourseTrainerListApi = 'training-e-learning-service/assign-course-trainer/list'
export const getTrainerApi = 'training-e-learning-service/assign-course-trainer/trainer'
export const getCourseSyllabusApi = 'training-e-learning-service/assign-course-trainer/course-syllabus'
export const assignCourseTrainerStoreApi = 'training-e-learning-service/assign-course-trainer/store'
export const assignCourseTrainerUpdateApi = 'training-e-learning-service/assign-course-trainer/update'
export const assignCourseTrainerToggleApi = 'training-e-learning-service/assign-course-trainer/toggle-status'

// training routine
export const trainingRoutineListApi = 'training-plan-management/training-routine/list'
export const circularDataApi = 'training-plan-management/training-routine/circular-data'
export const moduleDataApi = 'training-plan-management/training-routine/module-data'
export const trainingRoutineStoreApi = 'training-plan-management/training-routine/store'
export const trainingRoutineUpdateApi = 'training-plan-management/training-routine/update'
export const trainingRoutineTrainerToggleApi = 'training-plan-management/training-routine/toggle-status'

// Trainee Attendance
export const traineeAttendance = 'training-plan-management/trainee-attendance'
export const getScheduleBatchTrainee = traineeAttendance + '/batch-trainee-list'
export const traineeEnrollListApi = traineeAttendance + '/list'
export const traineeAttendanceStoreApi = traineeAttendance + '/store'
export const getScheduleBatchTraineeAttendance = traineeAttendance + '/details'

// training-material-info
export const trainingMaterialListApi = 'training-e-learning-service/training-material-info/list'
export const trainingMaterialStoreApi = 'training-e-learning-service/training-material-info/store'
export const trainingMaterialUpdateApi = 'training-e-learning-service/training-material-info/update'
export const trainingMaterialToggleApi = 'training-e-learning-service/training-material-info/toggle-status'

// Budget Management
export const budgetManagement = 'training-plan-management/budget-management'
export const budgetManagementListApi = budgetManagement + '/list'
export const budgetManagementStoreApi = budgetManagement + '/store'
export const budgetManagementUpdateApi = budgetManagement + '/update'

// events-awards
export const eventsAwardsListApi = 'training-e-learning-service/events-awards/list'
export const eventsAwardsStoreApi = 'training-e-learning-service/events-awards/store'
export const eventsAwardsUpdateApi = 'training-e-learning-service/events-awards/update'
export const eventsAwardsToggleApi = 'training-e-learning-service/events-awards/toggle-status'

// training question Management
export const questionManagement = 'training-plan-management/training-question'
export const questionManagementListApi = questionManagement + '/list'
export const questionManagementStoreApi = questionManagement + '/store'
export const questionManagementUpdateApi = questionManagement + '/update'
